// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gswgqetflxbhfpcyaghp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imdzd2dxZXRmbHhiaGZwY3lhZ2hwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQzNTg5NTksImV4cCI6MjA0OTkzNDk1OX0.AimWiEyE1iXbcyFwRmh2Nzf1k1XmdVviJen1RHNwH-Q";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);